<div class="row">
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs border-bottom tw-text-center"
    [destroyOnHide]="false"
    [activeId]="selectedMode"
    (activeIdChange)="onChangeMode($event)"
  >
    <!-- manual -->
    <ng-container [ngbNavItem]="'manual'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <i class="mdi mdi-keyboard text-navyBlue tw-mr-1 mdi-24px"></i>
        <span class="tw-mt-1 tw-mr-2 tw-text-lg text-dark">{{
          "common.manual" | translate
        }}</span>
      </a>

      <!-- 1 -->
      <ng-template ngbNavContent>
        <!-- alert -->
        <div class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mt-1">
          <details
            #manualAlertDetails
            (click)="onChangeAlertDetailsInManualMode(manualAlertDetails)"
          >
            <summary class="tw-font-semibold text-navyBlue">
              {{ "common.help" | translate }}
              <span *ngIf="!isShowAlertDetailsInManualMode"
                >( {{ "common.clickForMoreInfo" | translate }} )</span
              >
            </summary>
            <div
              class="dark:tw-text-gray-300"
              [innerHTML]="
                'components.mobilesAnalysis.manualAddDescription'
                  | translate
                    : {
                        number: maxMobileNumbersInManualMode | numberSeparator,
                        clipBoard: 'common.clipBoard' | translate
                      }
              "
            ></div>
          </details>
        </div>

        <div class="row">
          <!-- correct mobile Numbers -->
          <div [classList]="input_responsiveClass">
            <mat-form-field appearance="outline" class="tw-w-full">
              <!-- label -->
              <mat-label [class.text-xl]="countOfCorrectMobileNumber">
                <!-- {{input_title|translate}} -->
                {{ "components.mobilesAnalysis.correctNumbers" | translate }}
                <ng-container>
                  <span>(</span
                  >{{ mobileNumbersCountInManualMode | numberSeparator
                  }}<span>)</span>
                </ng-container>
              </mat-label>

              <div class="text-editor">
                <!-- text area -->
                <!-- TODO textarea torbatian -->
                <textarea
                  class="font-vazir-ui"
                  [(ngModel)]="mobileNumbersInManualMode"
                  matInput
                  [readonly]="pastedLoading"
                  autocomplete="off"
                  [rows]="input_correctRows"
                  (keydown)="checkInputText($event)"
                  (change)="checkInputText($event)"
                  (paste)="checkPastedText($event)"
                ></textarea>
                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      [matMenuTriggerFor]="downloadFile"
                      *ngIf="
                        mobileNumbersFileInManualMode;
                        else disableDownload
                      "
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>
                    <mat-menu #downloadFile="matMenu">
                      <div
                        class="border-bottom tw-h-[35px] tw-w-[150px] tw-flex-center"
                      >
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          (click)="downloadMobileNumbersExcelFile()"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadExcel"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>

                      <div class="tw-h-[35px] tw-w-[150px] tw-flex-center">
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          [href]="mobileNumbersFileInManualMode"
                          download="MobileNumbers.txt"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadText"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>
                    </mat-menu>

                    <ng-template #disableDownload>
                      <a class="disable">
                        <i class="mdi mdi-tray-arrow-down text-gray"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="mobileNumbersInManualMode; else disableEraser"
                      (click)="clearCorrectMobileNumbers()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="mobileNumbersInManualMode; else disableCopy"
                      (click)="copyToClipboard(mobileNumbersInManualMode)"
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>
                </div>

                <div class="pasted__loading" *ngIf="pastedLoading">
                  <div
                    class="spinner-border text-primary tw-pb-2"
                    role="status"
                  ></div>
                  <span> {{ "common.loading" | translate }}</span>
                </div>
              </div>
            </mat-form-field>
          </div>

          <!-- wrong mobile  -->
          <div [classList]="input_responsiveClass" *ngIf="input_showWrongTexts">
            <mat-form-field appearance="outline" class="tw-w-full">
              <mat-label
                [class.text-xl]="wrongMobileNumbersCountInManualMode"
                [class.text-danger]="wrongMobileNumbersInManualMode"
              >
                {{ "components.mobilesAnalysis.wrongNumbers" | translate }}
                <ng-container *ngIf="wrongMobileNumbersCountInManualMode">
                  <span>(</span>
                  {{ wrongMobileNumbersCountInManualMode | numberSeparator }}
                  <span>)</span>
                </ng-container>
              </mat-label>

              <div class="text-editor">
                <!-- TODO textarea torbatian -->
                <textarea
                  class="font-vazir-ui"
                  matInput
                  [rows]="input_wrongRows"
                  readonly
                  [(ngModel)]="wrongMobileNumbersInManualMode"
                  spellcheck="false"
                  autocomplete="off"
                  [class.text-danger]="wrongMobileNumbersInManualMode"
                  [ngModelOptions]="{ standalone: true }"
                ></textarea>

                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      [matMenuTriggerFor]="downloadWrongFile"
                      *ngIf="
                        wrongMobileNumbersCountInManualMode > 0;
                        else disableWrongFileDownload
                      "
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>

                    <mat-menu #downloadWrongFile="matMenu">
                      <div
                        class="border-bottom tw-h-[35px] tw-w-[150px] tw-flex-center"
                      >
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          (click)="downloadWrongMobileNumbersExcelFile()"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadExcel"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>

                      <div class="tw-h-[35px] tw-w-[150px] tw-flex-center">
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          [href]="wrongMobileNumbersFileInManualMode"
                          download="WrongMobileNumbers.txt"
                        >
                          <span>{{
                            "components.mobilesAnalysis.downloadText"
                              | translate
                          }}</span>
                        </a>
                      </div>
                    </mat-menu>

                    <ng-template #disableWrongFileDownload>
                      <a class="disable">
                        <i class="mdi mdi-tray-arrow-down text-gray"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="
                        wrongMobileNumbersInManualMode;
                        else disableEraser2
                      "
                      (click)="clearWrongMobileNumbers()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser2>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="wrongMobileNumbersInManualMode; else disableCopy"
                      (click)="copyToClipboard(wrongMobileNumbersInManualMode)"
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- duplicated numbers -->
                  <!-- <div class="tw-mb-2 tw-mt-2 tw-ml-[10px] ltr:tw-mr-[10px]">
                    <mat-menu #duplicatedNumbers="matMenu">
                      <div class="tw-p-[11px] tw-flex tw-justify-between tw-items-center tw-h-[50px]">
                        <div> {{'common.duplicatedNumbersCount'|translate}} </div>
                        <div>
                          <span copyToClipboard
                            class="badge badge-light border tw-text-gray-800 tw-text-[13px] tw-whitespace-nowrap tw-overflow-x-scroll tw-mr-2 tw-mt-3"
                            [innerHTML]="duplicatedMobileNumbersCountInManualMode || '-'"></span>
                        </div>
                      </div>
                    </mat-menu>
                    <ng-template #disableDuplicated>
                      <a class="opacity-5">
                        <img src="/assets/media/svg/icons/file-phone-outline.svg" class="tw-mx-1" width="23"
                          alt="duplicatedNumbersCount">
                      </a>
                    </ng-template>
                  </div> -->
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- upload file -->
    <ng-container [ngbNavItem]="'uploadFile'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <i class="mdi mdi-tray-arrow-up text-success tw-mr-1 mdi-22px"></i>
        <span class="tw-mt-1 tw-mr-2 tw-text-lg text-dark">{{
          "common.fileUpload" | translate
        }}</span>
      </a>

      <!-- 2 -->
      <ng-template ngbNavContent>
        <!-- alert -->
        <div class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mt-1">
          <details
            #manualAlertDetails
            (click)="onChangeAlertDetailsInManualMode(manualAlertDetails)"
          >
            <summary class="tw-font-semibold text-navyBlue">
              {{ "common.help" | translate }}
              <span *ngIf="!isShowAlertDetailsInManualMode"
                >( {{ "common.clickForMoreInfo" | translate }} )</span
              >
            </summary>
            <div
              class="dark:tw-text-gray-300"
              [innerHTML]="
                'components.mobilesAnalysis.uploadAddDescription'
                  | translate
                    : {
                        fileTypes: fileTypes?.join(),
                        maxFileSize: maxFileSize,
                        maxMobileNumbers: maxMobileNumbers | numberSeparator
                      }
              "
            ></div>
          </details>
        </div>

        <file-uploader
          [progress]="progress"
          [label]="'common.file' | translate"
          class="tw-w-[275px]"
          (onClearFile)="checkIsNullFile($event)"
          (valueChange)="checkFile($event)"
          acceptFile=".txt,.xls,.xlsx,.csv"
          [maxFileSize]="maxFileSize"
          sizeType="mb"
          (onErrorFile)="showErrorDialog($event)"
        >
        </file-uploader>

        <!-- isNeedUserConfirmation -->
        <div
          *ngIf="
            uploadFileToServer && !isInquireBlackList && input_id != 'numbers'
          "
        >
          <mat-slide-toggle
            formControlName="isPercentage"
            [(ngModel)]="isNeedUserConfirmation"
            (change)="changeIsNeedUserConfirmation($event)"
          >
            {{ "common.isNeedUserConfirmation" | translate }}</mat-slide-toggle
          >
        </div>

        <div
          *ngIf="!uploadFileToServer"
          class="tw-mt-[5px] tw-mb-[10px] alert alert-white border tw-flex tw-justify-between tw-items-center"
        >
          <span>
            {{ "common.count" | translate }} {{ input_title | translate }} :
          </span>
          <span
            class="tw-font-semibold tw-text-[15px] text-dark"
            *ngIf="!pastedLoading"
          >
            {{ mobileNumbersCountInUploadFileMode | numberSeparator }}
          </span>
          <span *ngIf="pastedLoading">
            <span
              class="spinner-border text-primary spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span class="sr-only">Loading...</span>
          </span>
        </div>

        <!-- wrong mobile  -->
        <div *ngIf="input_showWrongTexts && !uploadFileToServer">
          <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label
              [class.text-xl]="wrongMobileNumbersCountInUploadFileMode > 0"
              [class.text-danger]="wrongMobileNumbersCountInUploadFileMode > 0"
            >
              {{ "components.mobilesAnalysis.wrongNumbers" | translate }}
              <ng-container *ngIf="wrongMobileNumbersCountInUploadFileMode > 0">
                <span>(</span>
                {{ wrongMobileNumbersCountInUploadFileMode | numberSeparator }}
                <span>)</span>
              </ng-container>
            </mat-label>

            <div class="text-editor">
              <!-- TODO textarea torbatian -->
              <textarea
                class="font-vazir-ui"
                matInput
                [rows]="5"
                readonly
                [(ngModel)]="wrongMobileNumbersInUploadFileMode"
                spellcheck="false"
                autocomplete="off"
                [class.text-danger]="wrongMobileNumbersInUploadFileMode"
                [ngModelOptions]="{ standalone: true }"
              ></textarea>

              <div
                class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
              >
                <!-- download -->
                <div class="tw-mb-2">
                  <a
                    [matTooltip]="'common.downloadFile' | translate"
                    [matMenuTriggerFor]="downloadWrongFile"
                    *ngIf="
                      wrongMobileNumbersCountInUploadFileMode > 0;
                      else disableWrongFileDownload
                    "
                  >
                    <i class="mdi mdi-tray-arrow-down text-gray"></i>
                  </a>

                  <mat-menu #downloadWrongFile="matMenu">
                    <div
                      class="border-bottom tw-h-[35px] tw-w-[150px] tw-flex-center"
                    >
                      <a
                        class="tw-font-medium tw-cursor-pointer text-dark"
                        (click)="downloadWrongMobileNumbersExcelFile()"
                      >
                        <span>
                          {{
                            "components.mobilesAnalysis.downloadExcel"
                              | translate
                          }}
                        </span>
                      </a>
                    </div>

                    <div class="tw-h-[35px] tw-w-[150px] tw-flex-center">
                      <a
                        class="tw-font-medium tw-cursor-pointer text-dark"
                        [href]="wrongMobileNumbersFileInUploadFileMode"
                        download="WrongMobileNumbers.txt"
                      >
                        <span>{{
                          "components.mobilesAnalysis.downloadText" | translate
                        }}</span>
                      </a>
                    </div>
                  </mat-menu>

                  <ng-template #disableWrongFileDownload>
                    <a class="disable">
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>
                  </ng-template>
                </div>

                <!-- eraser -->
                <div class="tw-mb-2">
                  <a
                    [matTooltip]="'common.clear' | translate"
                    *ngIf="
                      wrongMobileNumbersInUploadFileMode;
                      else disableEraser2
                    "
                    (click)="clearWrongMobileNumbers()"
                  >
                    <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                  </a>
                  <ng-template #disableEraser2>
                    <a class="disable">
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                  </ng-template>
                </div>

                <!-- copy -->
                <div class="tw-mb-2 tw-mt-1">
                  <a
                    [matTooltip]="'common.copy' | translate"
                    *ngIf="wrongMobileNumbersInUploadFileMode; else disableCopy"
                    (click)="
                      copyToClipboard(wrongMobileNumbersInUploadFileMode)
                    "
                  >
                    <i
                      class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                    ></i>
                  </a>
                  <ng-template #disableCopy>
                    <a class="disable">
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                  </ng-template>
                </div>
              </div>
            </div>
          </mat-form-field>
        </div>
      </ng-template>
    </ng-container>

    <!-- clipboard -->
    <ng-container [ngbNavItem]="'clipboard'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <i class="mdi mdi-content-paste text-info tw-mr-1 mdi-22px"></i>
        <span class="tw-mt-1 tw-mr-2 tw-text-lg text-dark">{{
          "common.clipBoard" | translate
        }}</span>
      </a>

      <!-- 3 -->
      <ng-template ngbNavContent>
        <!-- alert -->
        <div class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mt-1">
          <details
            #manualAlertDetails
            (click)="onChangeAlertDetailsInManualMode(manualAlertDetails)"
          >
            <summary class="tw-font-semibold text-navyBlue">
              {{ "common.help" | translate }}
              <span *ngIf="!isShowAlertDetailsInManualMode"
                >( {{ "common.clickForMoreInfo" | translate }} )</span
              >
            </summary>
            <div
              class="dark:tw-text-gray-300"
              [innerHTML]="
                'components.mobilesAnalysis.clipBoardAddDescription'
                  | translate
                    : {
                        maxMobileNumbers:
                          maxMobileNumbersInClipBoardMode | numberSeparator
                      }
              "
            ></div>
          </details>
        </div>

        <div class="row">
          <!-- correct mobile Numbers -->
          <div [classList]="input_responsiveClass">
            <mat-form-field appearance="outline" class="tw-w-full">
              <!-- label -->
              <mat-label
                [class.text-xl]="
                  mobileNumbersCountInClipboardMode | numberSeparator
                "
              >
              </mat-label>

              <div class="text-editor tw-relative">
                <!-- text area -->
                <!-- TODO textarea torbatian -->
                <textarea
                  matInput
                  [readonly]="true"
                  autocomplete="off"
                  [rows]="5"
                  (paste)="checkPastedText($event)"
                  [id]="input_id + '-clipboard-textarea'"
                  class="text-white font-vazir-ui"
                  style="resize: none; overflow: hidden"
                >
                </textarea>

                <span
                  *ngIf="!mobileNumbersInClipboardMode && !pastedLoading"
                  class="absolute-center text-gray tw-font-normal tw-text-[14px]"
                  style="line-height: 1.7"
                >
                  <span
                    class="dark:tw-text-gray-200"
                    [innerHTML]="
                      'components.mobilesAnalysis.pasteNumber' | translate
                    "
                  ></span>
                </span>
                <div
                  *ngIf="mobileNumbersInClipboardMode && !pastedLoading"
                  class="absolute-center text-gray tw-font-medium"
                  style="line-height: 1.5"
                >
                  <div
                    [innerHTML]="
                      'components.mobilesAnalysis.numberRegistered'
                        | translate
                          : {
                              downloadFile: 'common.downloadFile' | translate,
                              mobileNumbersCountInClipboardMode:
                                mobileNumbersCountInClipboardMode
                                | numberSeparator
                            }
                    "
                  ></div>
                </div>

                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- paste -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.replace' | translate"
                      (click)="getDataFromClipboard()"
                    >
                      <i
                        class="mdi mdi-clipboard-arrow-down-outline text-navyBlue tw-mt-1"
                      ></i>
                    </a>
                  </div>

                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      [matMenuTriggerFor]="downloadFile"
                      *ngIf="
                        mobileNumbersCountInClipboardMode > 0;
                        else disableDownload
                      "
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>
                    <mat-menu #downloadFile="matMenu">
                      <div
                        class="border-bottom tw-h-[35px] tw-w-[150px] tw-flex-center"
                      >
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          (click)="downloadMobileNumbersExcelFile()"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadExcel"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>

                      <div class="tw-h-[35px] tw-w-[150px] tw-flex-center">
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          [href]="mobileNumbersFileInClipboardMode"
                          download="MobileNumbers.txt"
                        >
                          <span>{{
                            "components.mobilesAnalysis.downloadText"
                              | translate
                          }}</span>
                        </a>
                      </div>
                    </mat-menu>

                    <ng-template #disableDownload>
                      <a class="disable">
                        <i class="mdi mdi-tray-arrow-down text-gray"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="
                        mobileNumbersCountInClipboardMode;
                        else disableEraser
                      "
                      (click)="clearCorrectMobileNumbers()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="mobileNumbersInClipboardMode; else disableCopy"
                      (click)="copyToClipboard(mobileNumbersInClipboardMode)"
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>
                </div>

                <div class="pasted__loading" *ngIf="pastedLoading">
                  <div
                    class="spinner-border text-primary tw-pb-2"
                    role="status"
                  ></div>
                  <span> {{ "common.loading" | translate }}</span>
                </div>
              </div>
            </mat-form-field>
          </div>

          <!-- wrong mobile  -->
          <div [classList]="input_responsiveClass" *ngIf="input_showWrongTexts">
            <mat-form-field appearance="outline" class="tw-w-full">
              <mat-label
                [class.text-xl]="wrongMobileNumbersCountInClipboardMode"
                [class.text-danger]="wrongMobileNumbersInClipboardMode"
              >
                {{ "components.mobilesAnalysis.wrongNumbers" | translate }}
                <ng-container *ngIf="wrongMobileNumbersCountInClipboardMode">
                  <span>(</span>
                  {{ wrongMobileNumbersCountInClipboardMode | numberSeparator }}
                  <span>)</span>
                </ng-container>
              </mat-label>

              <div class="text-editor">
                <!-- TODO textarea torbatian -->
                <textarea
                  class="font-vazir-ui"
                  matInput
                  [rows]="7"
                  readonly
                  [(ngModel)]="wrongMobileNumbersInClipboardMode"
                  spellcheck="false"
                  autocomplete="off"
                  [class.text-danger]="wrongMobileNumbersInClipboardMode"
                  [ngModelOptions]="{ standalone: true }"
                  style="min-height: 164px"
                ></textarea>

                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      [matMenuTriggerFor]="downloadWrongFile"
                      *ngIf="
                        wrongMobileNumbersCountInClipboardMode > 0;
                        else disableWrongFileDownload
                      "
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>

                    <mat-menu #downloadWrongFile="matMenu">
                      <div
                        class="border-bottom tw-h-[35px] tw-w-[150px] tw-flex-center"
                      >
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          (click)="downloadWrongMobileNumbersExcelFile()"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadExcel"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>

                      <div class="tw-h-[35px] tw-w-[150px] tw-flex-center">
                        <a
                          class="tw-font-medium tw-cursor-pointer text-dark"
                          [href]="wrongMobileNumbersFileInClipboardMode"
                          download="WrongMobileNumbers.txt"
                        >
                          <span>
                            {{
                              "components.mobilesAnalysis.downloadText"
                                | translate
                            }}
                          </span>
                        </a>
                      </div>
                    </mat-menu>

                    <ng-template #disableWrongFileDownload>
                      <a class="disable">
                        <i class="mdi mdi-tray-arrow-down text-gray"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="
                        wrongMobileNumbersInClipboardMode;
                        else disableEraser2
                      "
                      (click)="clearWrongMobileNumbers()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser2>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="
                        wrongMobileNumbersInClipboardMode;
                        else disableCopy
                      "
                      (click)="
                        copyToClipboard(wrongMobileNumbersInClipboardMode)
                      "
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- duplicated numbers -->
                  <!-- <div class="tw-mb-2 tw-mt-1 tw-ml-[10px] ltr:tw-mr-[10px]">
                    <a [matTooltip]="'common.duplicatedNumbersCount'|translate" [matMenuTriggerFor]="duplicatedNumbers"
                      *ngIf="duplicatedMobileNumbersCountInClipboardMode>0;else disableDuplicated">
                      <img src="/assets/media/svg/icons/file-phone-outline.svg" class="tw-mx-1" width="23"
                        alt="duplicatedNumbersCount">
                    </a>

                    <mat-menu #duplicatedNumbers="matMenu">
                      <div class="tw-p-[11px] tw-flex tw-justify-between tw-items-center tw-h-[50px]">
                        <div> {{'common.duplicatedNumbersCount'|translate}} </div>
                        <div>
                          <span copyToClipboard
                            class="badge badge-light border tw-text-gray-800 tw-text-[13px] tw-whitespace-nowrap tw-overflow-x-scroll tw-mr-2 tw-mt-3"
                            [innerHTML]="duplicatedMobileNumbersCountInClipboardMode || '-'"></span>
                        </div>
                      </div>
                    </mat-menu>
                    <ng-template #disableDuplicated>
                      <a class="opacity-5">
                        <img src="/assets/media/svg/icons/file-phone-outline.svg" class="tw-mx-1" width="23"
                          alt="duplicatedNumbersCount">
                      </a>
                    </ng-template>
                  </div> -->
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
</div>

<div class="d-none" [formGroup]="input_form">
  <input
    type="text"
    class="dir-ltr"
    [formControlName]="input_formControlName"
    [(ngModel)]="mobileNumbers"
  />
</div>
